let isPageUnloading = false

export const markUploadPageUnloading = () => {
  isPageUnloading = true
}

export const resetUploadPageLifecycle = () => {
  isPageUnloading = false
}

export const isUploadPageUnloading = () => isPageUnloading
